'use client';

import { useState } from 'react';
import type { ParallelAgentExecution } from './parallel-agent-execution';
import {
  useParallelAgentBatch,
  type ParallelAgentBatchState,
} from './useParallelAgentBatch';

export type RunningAgentsView =
  | { panel: 'collapsed' }
  | { panel: 'list'; batchId: string }
  | { panel: 'detail'; batchId: string; toolCallId: string };

export const COLLAPSED_RUNNING_AGENTS_VIEW: RunningAgentsView = {
  panel: 'collapsed',
};

export type RunningAgentsState = ParallelAgentBatchState & {
  view: RunningAgentsView;
  setView: (view: RunningAgentsView) => void;
};

export function useRunningAgents({
  executions,
}: {
  executions: readonly ParallelAgentExecution[];
}): RunningAgentsState {
  const [view, setView] = useState<RunningAgentsView>(
    COLLAPSED_RUNNING_AGENTS_VIEW,
  );
  const batch = useParallelAgentBatch({
    executions,
    expandedBatchId: view.panel === 'collapsed' ? undefined : view.batchId,
  });

  return { ...batch, view, setView };
}
